import { AnalyticsDashboard } from "@/components/skills/analytics/AnalyticsDashboard";

export function AnalyticsPage() {
  return <AnalyticsDashboard />;
}
